import React from "react";
import { useParams } from "react-router-dom";
import { CustomList } from "components";
import { HoursCell } from "@/components/hours/cell";
import { useJob } from "@/modules/work/jobs/context";
import JobTimesheetTagsFilters from "./filters";
import { TagCell } from "./_cell";

export default function JobTimesheetTags() {
    const { jobId } = useParams();
    const { project, type } = useJob();

    const isFixedOrDedicated = ["fixed", "dedicated"].includes(type);

    const columns = [
        {
            id: "tag",
            header: "Tag",
            accessorKey: "tag",
            cell: TagCell,
        },
        {
            id: "logged",
            header: "Logged",
            accessorKey: "logged",
            cell: HoursCell,
        },
        ...(isFixedOrDedicated
          ? [
              {
                id: "spent",
                accessorKey: "spent",
                header: "Spent",
                cell: HoursCell,
              },
            ]
          : []),
        {
            id: "approved",
            accessorKey: "approved",
            header: "Approved",
            cell: HoursCell,
        },
        ...(isFixedOrDedicated
          ? [
              {
                id: "consumed",
                accessorKey: "consumed",
                header: "Consumed",
                cell: HoursCell,
              },
            ]
          : []),
        {
            id: "unreviewed",
            header: "Unreviewed",
            accessorKey: "unreviewed",
            cell: HoursCell,
        },
    ];

    const defaultFilters = {
        jobId,
        projectId: project.id,
    };

    return (
        <div className=" flex-1 overflow-auto" key={defaultFilters}>
            <CustomList
                title="Tags"
                storageKey={`${jobId}-${project.id}-tags`}
                endPoint="custom-ui/get-tag-wise-timesheet-summary-for-project"
                filters={defaultFilters}
                columns={columns}
                hidePagination={true}
                renderFilters={JobTimesheetTagsFilters}
                teleportFilters={true}
            />
        </div>
    );
}
